import { Component, Input, HostBinding } from "@angular/core";

@Component({
  selector: "split-screen",
  templateUrl: "splitScreen.component.html",
  styleUrls: ["splitScreen.component.scss"],
})

/**
 * Provide functionality to Horizontal Split Screen. Usage:
 * <split-screen>
 *     <div>Left Side</div>
 *     <aside>Right Side</div>
 * </split-screen>
 */
export class SplitScreen {
  @Input()
  isAsideCollapsible = false;

  constructor() {}

  /**
   * Booting up the component
   * @retrun void
   */
  ngOnInit() {}
}
